import { compose } from '@effable/misc';

import { withAnalytics } from './with-analytics';
import { withEffector } from './with-effector';
import { withFresnel } from './with-fresnel';

export const withProviders = compose(withAnalytics, withEffector, withFresnel);
